import GarbageIcon from './component'

export default GarbageIcon
